import { reflect } from '@effector/reflect';
import { CircleSlash2 } from 'lucide-react';
import { equals, not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { USER_ROLES } from 'shared/api';
import { translated } from 'shared/lib';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { UnblockVoucherModel } from '../../model';

export const createUnblockVoucherModal = (model: UnblockVoucherModel) => {
	const ConfirmModal = createConfirmModal(model);

	const UnblockVoucherModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		return (
			<ConfirmModal
				ref={ref}
				title={t('unblock-voucher.title')}
				cancelButtonProps={{
					children: t('unblock-voucher.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('unblock-voucher.unblock'),
				}}
				{...props}
			>
				{t('unblock-voucher.description')}
			</ConfirmModal>
		);
	});

	const UnblockVoucherModalButton = reflect({
		view: ConfirmModal.Button,
		bind: {
			'data-test-id': 'unblock-voucher-button',
			variant: 'outline',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			leftSection: <CircleSlash2 />,
			children: translated('unblock-voucher.unblock'),
		},
	});

	const UnblockVoucherModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'unblock-voucher-action-icon',
			variant: 'ghost-destructive',
			disabled: not(equals(viewerModel.$role, USER_ROLES.god)),
			children: <CircleSlash2 />,
		},
	});

	return Object.assign(UnblockVoucherModal, {
		Button: UnblockVoucherModalButton,
		ActionIcon: UnblockVoucherModalActionIcon,
	});
};
